import { Badge, Icon } from '@/components/ui';

/** Marks an applicant on Student Premium. A tag, not a status. */
export function PremiumBadge() {
  return (
    <Badge tone="brand" title="This applicant is on Student Premium">
      <Icon name="sparkles" size={12} />
      Premium
    </Badge>
  );
}
